export const locale = {
    lang: 'en',
    data: {
        PHONES_LIST: {
            TITLES: {
                EMPTY: 'You have not saved a phone number.',
                USED_FOR_ALERTS: 'Used For Alerts'
            }
        }
    }
};